import { render, staticRenderFns } from "./PublicProfileEducation.vue?vue&type=template&id=2179a67e&"
import script from "./PublicProfileEducation.vue?vue&type=script&lang=js&"
export * from "./PublicProfileEducation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports